import React from 'react';
import ReactQuill from 'react-quill';
import { Select } from 'antd';

const BookingPolicySection = ({
    policies,
    setPolicies,
    bookingPeriod,
    setBookingPeriod,
    bufferTime,
    setBufferTime,
    depositPercentage,
    setDepositPercentage,
    modules,
    formats,
}) => {
    return (
        <>
            <div className="border-b-1-e1e6ef my-30" />

            <h6 className="m-0 mb-1 pb-12 f-22 fw-normal poly c-0f151d">
                Booking Rules & Policy
            </h6>

            <div>
                <label className="w-100">
                    <ReactQuill
                        theme="snow"
                        value={policies}
                        onChange={setPolicies}
                        placeholder="Enter rules and policy"
                        style={{
                            height: '200px',
                            maxHeight: '400px',
                        }}
                        modules={modules}
                        formats={formats}
                    />
                </label>
            </div>

            <div className="border-b-1-e1e6ef my-30" />

            <div className="pb-16 w-100">
                <h6 className="f-14 fw-normal poppins text-gray">
                    Advanced booking period
                </h6>
                <label className="label-search position-relative poppins w-100">
                    <input
                        className="input-search ps-0"
                        type="text"
                        name="bookingPeriod"
                        value={(bookingPeriod === null || bookingPeriod === undefined) ? '' : bookingPeriod}
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue === '') {
                                setBookingPeriod('');
                            } else if (/^(0|[1-9]\d*)$/.test(inputValue)) {
                                setBookingPeriod(inputValue);
                            }
                        }}
                    />
                    <div
                        className="input-unit"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        days
                    </div>
                </label>
            </div>

            <div className="pb-16 w-100">
                <h6 className="f-14 fw-normal poppins text-gray">
                    Select your service buffer time (in minutes)
                </h6>
                <Select
                    className="w-100"
                    value={bufferTime}
                    onChange={(value) => setBufferTime(value)}
                    placeholder="Select buffer time"
                >
                    {[15, 30, 45, 60].map((minutes) => (
                        <Select.Option key={minutes} value={minutes}>
                            {minutes} minutes
                        </Select.Option>
                    ))}
                </Select>
            </div>

            <div className="pb-16 w-100">
                <h6 className="f-14 fw-normal poppins text-gray">
                    Upfront Deposit Percentage
                </h6>
                <Select
                    className="w-100"
                    value={depositPercentage}
                    onChange={(value) => setDepositPercentage(value)}
                    placeholder="Select Upfront Deposit Percentage"
                >
                    <Select.Option value={null}>
                        Select Percentage
                    </Select.Option>
                    {[10, 20, 30, 50].map((percent) => (
                        <Select.Option key={percent} value={percent}>
                            {percent} Percent
                        </Select.Option>
                    ))}
                </Select>
            </div>
        </>
    );
};

export default BookingPolicySection;
